import { SVGProps } from 'react'

export const ShoppingBagPlusIcon = ({ width = '24', height = '25', ...props }: SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 9.92505C5 8.82048 5.89543 7.92505 7 7.92505H17C18.1046 7.92505 19 8.82048 19 9.92505V18.925C19 20.5819 17.6569 21.925 16 21.925H8C6.34315 21.925 5 20.5819 5 18.925V9.92505Z"
      stroke="#6B7B3C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10.925V6.92505C15 5.26819 13.6569 3.92505 12 3.92505V3.92505C10.3431 3.92505 9 5.26819 9 6.92505V10.925"
      stroke="#6B7B3C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="18.5" cy="6.42505" r="4.5" fill="#FAFAFA" />
    <mask id="path-4-inside-1_562_3922" fill="white">
      <path d="M18.5 2.92505C20.433 2.92505 22 4.49205 22 6.42505C22 8.35805 20.433 9.92505 18.5 9.92505C16.567 9.92505 15 8.35805 15 6.42505C15 4.49205 16.567 2.92505 18.5 2.92505Z" />
    </mask>
    <path
      d="M18.5 2.92505C20.433 2.92505 22 4.49205 22 6.42505C22 8.35805 20.433 9.92505 18.5 9.92505C16.567 9.92505 15 8.35805 15 6.42505C15 4.49205 16.567 2.92505 18.5 2.92505Z"
      fill="#6B7B3C"
    />
    <path
      d="M18.5 2.92505V3.92505C19.8807 3.92505 21 5.04434 21 6.42505H22H23C23 3.93977 20.9853 1.92505 18.5 1.92505V2.92505ZM22 6.42505H21C21 7.80576 19.8807 8.92505 18.5 8.92505V9.92505V10.925C20.9853 10.925 23 8.91033 23 6.42505H22ZM18.5 9.92505V8.92505C17.1193 8.92505 16 7.80576 16 6.42505H15H14C14 8.91033 16.0147 10.925 18.5 10.925V9.92505ZM15 6.42505H16C16 5.04434 17.1193 3.92505 18.5 3.92505V2.92505V1.92505C16.0147 1.92505 14 3.93977 14 6.42505H15Z"
      fill="#6B7B3C"
      mask="url(#path-4-inside-1_562_3922)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5002 4.19775C18.7052 4.19775 18.8714 4.36395 18.8714 4.56897V6.05381L20.3563 6.05381C20.5613 6.05381 20.7275 6.22001 20.7275 6.42503C20.7275 6.63004 20.5613 6.79624 20.3563 6.79624H18.8714V8.28109C18.8714 8.4861 18.7052 8.6523 18.5002 8.6523C18.2952 8.6523 18.129 8.4861 18.129 8.28109L18.129 6.79624L16.6442 6.79624C16.4391 6.79624 16.2729 6.63004 16.2729 6.42503C16.2729 6.22001 16.4391 6.05381 16.6442 6.05381L18.129 6.05381V4.56897C18.129 4.36395 18.2952 4.19775 18.5002 4.19775Z"
      fill="#FAFAFA"
    />
  </svg>
)
